import styled from 'styled-components';
import { Colors } from 'core/CssVariables';
import { Row } from 'components/Base/Grid';

export const SRow = styled(Row)`
  height: 100%;
  text-align: center;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    .banner-container {
      text-align: center;
      .logo {
        height: 64px;
        //margin-top: 110px;
        margin-bottom: 120px;
      }
    }
  }
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${Colors.PrimaryColor};
  }
`;

export const SPage = styled.div<{ $isSmall?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  width: 55%;
  min-width: 386px;
  max-width: 500px;
  height: ${({ $isSmall }) => ($isSmall ? 91 : 80)}vh;
  background: ${Colors.White};
  border-radius: 20px;
  .content-container {
    width: 100%;
    max-height: calc(100% - 16px);
    overflow: auto;
    padding: 12px 24px 8px 32px;
    margin: 8px 8px 8px 0;
  }

  .ant-alert {
    margin-top: -44px;
    margin-bottom: 6px;
  }

  .verification-code-wrapper {
    width: fit-content;
    margin: 0 auto 24px;
  }
`;
